<div class="full-height mobile-padding">
  <h1 class="heading" [innerHTML]="'RIAM_PAGE.TITLE' | translate"></h1>
  <div class="info-banner">
    <p rbcTextStyle kind="paragraph" size="xl" [innerHTML]="'RIAM_PAGE.DESC_TEXT' | translate"></p>
  </div>
  <div>
    <p rbcTextStyle class="mb-16" kind="heading" size="sm" emphasis="default">
      {{ "RIAM_PAGE.EXISTING_PROFILE_HEADER" | translate }}
    </p>
  </div>
  <rbc-single-select-group [selectedItemId]="existingProfileSelection" (selectChange)="onSelectedItemChange($event)">
    <rbc-selectable-card
      class="login-container left-block"
      [selectableItem]="existingProfileYes"
      icon="profile"
      [heading]="'RIAM_PAGE.EXISTING_PROFILE_YES_HEADER' | translate"
      [description]="'RIAM_PAGE.EXISTING_PROFILE_YES_DESC' | translate"
    ></rbc-selectable-card>
    <rbc-selectable-card
      class="login-container right-block"
      [selectableItem]="existingProfileNo"
      icon="lock"
      [heading]="'RIAM_PAGE.EXISTING_PROFILE_NO_HEADER' | translate"
      [description]="'RIAM_PAGE.EXISTING_PROFILE_NO_DESC' | translate"
    ></rbc-selectable-card>
  </rbc-single-select-group>
  <div class="login-btn-container">
    <button class="login-btn" rbcCTA="primary" (click)="continue()">
      {{ "RIAM_PAGE.CONTINUE" | translate }}
    </button>
  </div>
</div>
